import { useEffect } from 'preact/hooks';
import { t } from '../i18n/index.js';
import { GameIcon } from './GameIcon.js';
import { MULTI_GAME_TYPES, type AnyGameType } from '../../shared/protocol.js';

/**
 * Game instructions (user request 2026-09-27): available in the lobby and during a game.
 * During a game the actual timers of that game are shown as well.
 */
export function RulesDialog(props: {
  game: AnyGameType;
  settings?: { turnTimeMs: number; timeBankMs: number; hitGrantsExtraShot?: boolean; incrementMs?: number };
  onClose: () => void;
}) {
  const { game, settings } = props;
  const common = (MULTI_GAME_TYPES as readonly string[]).includes(game)
    ? t.rules.commonMulti
    : game === 'snake' || game === 'tetrax' || game === 'chess'
      ? t.rules.commonRealtime
      : t.rules.common;

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && props.onClose();
    addEventListener('keydown', onKey);
    return () => removeEventListener('keydown', onKey);
  }, []);

  return (
    <div class="overlay" role="presentation" onClick={props.onClose}>
      <div class="dialog card rules" role="dialog" aria-modal="true" aria-labelledby="rules-title" onClick={(e) => e.stopPropagation()}>
        <div class="rules-head">
          <GameIcon game={game} size={34} />
          <h2 id="rules-title">{t.rules.title(t.games[game].name)}</h2>
        </div>
        <div class="rules-body">
          {settings && game === 'chess' && (
            <div class="rules-settings">
              <strong>{t.rules.thisGame}:</strong> {t.chess.clock} {t.chess.clockLabel(Math.round(settings.timeBankMs / 60000), Math.round((settings.incrementMs ?? 0) / 1000))}.
            </div>
          )}
          {settings && game !== 'snake' && game !== 'tetrax' && game !== 'chess' && (
            <div class="rules-settings">
              <strong>{t.rules.thisGame}:</strong> {t.rules.turnTime(Math.round(settings.turnTimeMs / 1000))},{' '}
              {t.rules.timeBank(Math.round(settings.timeBankMs / 1000))}.
              {game === 'battleship' && <> {settings.hitGrantsExtraShot ? t.rules.extraShotOn : t.rules.extraShotOff}</>}
            </div>
          )}
          {t.rules.games[game].map((section) => (
            <section>
              <h3>{section.heading}</h3>
              <ul>
                {section.items.map((item) => (
                  <li>{item}</li>
                ))}
              </ul>
            </section>
          ))}
          <section class="rules-common">
            <h3>{common.heading}</h3>
            <ul>
              {common.items.map((item) => (
                <li>{item}</li>
              ))}
            </ul>
          </section>
        </div>
        <div class="dialog-actions">
          <button class="btn btn-primary" onClick={props.onClose} autofocus>
            {t.rules.close}
          </button>
        </div>
      </div>
    </div>
  );
}
